import React, {useEffect, useRef} from 'react';
import {Dropdown} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {CapabilityOption} from './types';

export type ChatInputCommandsProps = {
    options: CapabilityOption[];
    onSelectCommand: (command: string | null) => void;
    isOpen: boolean;
    setFocus: boolean;
    onToggle: (nextShow: boolean) => void;
};

export const ChatInputCommands = ({
                                      options, isOpen, setFocus, onSelectCommand, onToggle,
                                  }: ChatInputCommandsProps): React.JSX.Element => {
    const {t} = useTranslation();
    const firstItemRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (isOpen && setFocus) {
            firstItemRef.current?.focus();
        }
    }, [isOpen, setFocus]);

    return (
        <Dropdown id="assistant-command-trigger" drop="up" title={t('assistant.capabilities.menu-trigger')}
                  className="assistant-command-trigger" onSelect={(eventKey) => onSelectCommand(eventKey)} show={isOpen}
                  onToggle={(nextShow) => onToggle(nextShow)}>
            <Dropdown.Toggle id="chat-input-toggle">
                @
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" className="commands-menu">
                {options.map((option) => {
                    return (
                        <Dropdown.Item key={option.commandLabel} eventKey={option.type} ref={firstItemRef}>
                            {option.label}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};
